module.exports = "<span data-ng-message=required>*required</span>";